(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["comfortflex-magnet-addon"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cf-magnet-addon')) {
    customElements.define('cf-magnet-addon', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.blockedHandles = this.dataset.handles.split(',');
        this.select = this.querySelector('select');
        this.form = this.querySelector('form');
        this.button = this.querySelector('[data-add]');
        this.dialog = this.querySelector('dialog');
        this.select?.addEventListener('change', () => this.updateChoice());
        this.form?.addEventListener('submit', (event) => this.addMagnet(event));
        this.querySelector('[data-preview]')?.addEventListener('click', () => this.dialog.showModal());
        this.querySelector('[data-close]')?.addEventListener('click', () => this.dialog.close());
        this.dialog?.addEventListener('click', (event) => {
          if (event.target === this.dialog) {
            const box = this.dialog.getBoundingClientRect();
            if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
          }
        });
        this.updateChoice();
        if (typeof subscribe === 'function') this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refreshEligibility());
        this.onPageShow = () => this.refreshEligibility();
        window.addEventListener('pageshow', this.onPageShow);
      }
      disconnectedCallback() {
        this.unsubscribe?.();
        window.removeEventListener('pageshow', this.onPageShow);
        this.initialized = false;
      }
      updateChoice() {
        if (!this.select) return;
        const choice = this.select.selectedOptions[0];
        for (const [selector, src] of [['.cf-magnet-addon__image', choice.dataset.image], ['.cf-magnet-addon__large', choice.dataset.large]]) {
          const image = this.querySelector(selector);
          image.removeAttribute('srcset');
          image.src = src;
          image.alt = choice.dataset.title;
        }
        this.querySelector('.cf-magnet-addon__price [data-price]').textContent = choice.dataset.price;
        this.querySelector('[data-dialog-title]').textContent = choice.dataset.title;
      }
      eligible(cart) {
        return cart.item_count > 0 && !cart.items.some((item) => this.blockedHandles.includes(item.handle));
      }
      async getCart() {
        const response = await fetch(`${this.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
        if (!response.ok) throw new Error('Cart unavailable');
        return response.json();
      }
      async refreshEligibility() {
        try { this.hidden = !this.eligible(await this.getCart()); } catch { /* Preserve server-rendered visibility on a transient network error. */ }
      }
      async addMagnet(event) {
        event.preventDefault();
        if (this.busy) return;
        this.busy = true;
        const label = this.button.textContent;
        const error = this.querySelector('[data-error-text]');
        this.button.disabled = true;
        this.button.textContent = this.dataset.loading;
        this.select.disabled = true;
        error.hidden = true;
        try {
          if (!this.eligible(await this.getCart())) {
            window.location.assign(this.dataset.cartUrl);
            return;
          }
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(this.select.value), quantity: 1 }] })
          });
          const result = await response.json();
          if (!response.ok || result.status) {
            error.textContent = result.description || this.dataset.error;
            error.hidden = false;
            return;
          }
          window.location.assign(this.dataset.cartUrl);
        } catch {
          error.textContent = this.dataset.error;
          error.hidden = false;
        } finally {
          this.busy = false;
          this.button.disabled = false;
          this.button.textContent = label;
          this.select.disabled = false;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
